import { LoadingOverlay } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import * as React from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../services/api';
import Report from './report';

export default function Custom(){
    const [pageData, setPageData] = React.useState<any>({});
    const [type, setType] = React.useState<string>(null);
    const [loading, setLoading] = React.useState(false);

    const { key } = useParams();

    React.useEffect(() => {
        setLoading(true);
        api.get(`/pages/${key}/details`)
        .then(({data : {type, data}}) => {
            if(!data) throw new Error("Página não encontrada");
            console.log({data})
            setLoading(false)
            setType(type);
            setPageData(data);
        })
        .catch(err => {
            window.location.href = "/"
            setLoading(false)
            showNotification({title: "Ops", message: err.message, color: 'red'});
        })
    }, [])
    
    return <>
        {loading
            ? <LoadingOverlay visible />
            : type === "new_themes"
                ? <Report type={type} {...pageData} />
                : <Report type={type} {...pageData} />}
    </>
}